import type { LoadingState } from './types';

const initialState: LoadingState = {
  global: {
    loading: false, // probably initial state should be true?
    counter: 0,
  },
};

export default initialState;
